module.exports = __webpack_public_path__ + "img/cis_1.cbb4ac63.jpg";